/**
 * Created by yniran on 12/19/14.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore"),
        CP_CONST = require("connection-const"),
        LE = require("app"),
        lpUtils = require("utils/lpUtils"),
        logger = require("logger").getLogger("LEConnection"),
        sanitizeTextActions = [
            {regEx: /\s+on\S+\s*=/gi, replaceString: " _eventRemoved=", type: "ONEVENT"},
            {regEx: /<.*iframe.*iframe\.*>/gi, replaceString: "", type: "IFRAME"},
            {regEx: /<.*script.*<.*\/.*script.*>/gi, replaceString: "", type: "SCRIPT"}
        ],
        kpRegex = /_KPDATA!:\{(.+)\}/,
        cbRegex = /data-lp-serviceid="([\w|#]*)"/,
        CHAT_LINE_SNIPPET_INDICATOR = "__KPDATA!:",
        COBROWSE_DATA_ATTR = 'data-lp-point="cb-offer"';

    /**
     * builds the info for sending a chat line to the server
     * @param options  = {text, profileAvatar, name, time, lastLine, reset, }
     */
    function getUserLineFromText(options) {

        var data = {
            line: {
                by: options.name,
                source: CP_CONST.CHAT_LINE_SOURCES.VISITOR,
                time: options.time,
                text: _getUserTextAsLines(options.text),
                textType: (lpUtils.hasHtml(options.text) ? "html" : "plain")
            },
            lastLine: options.lastLine,
            reset: options.reset,
            profileAvatar: options.profileAvatar
        };

        return getFormattedLine(data);
    }

    /**
     * builds the info for showing chat lines from the server
     * @param options  =  {line, lastLine, reset,  contactAvatar, visitorAvatar, contactName, skillChat}
     * @returns {*}
     */
    function getFormattedLine(options) {

        var formatted;

        if (options.line.text) {
            options.line.text = String(options.line.text);

            formatted = _getNewFormattedLine(options);

            if (formatted.lineType === CP_CONST.CHAT_LINE_TYPES.SNIPPET) {
                formatted = _getFormattedSnippet(formatted, options);
            } else if (formatted.lineType === CP_CONST.CHAT_LINE_TYPES.COBROWSE) {
                formatted = _getFormattedCoBrowseInvitation(formatted, options);
            } else {
                var needNewLine = _isNewLineNeeded(formatted, options.lastLine, options.reset);

                if (!needNewLine) {

                    formatted = options.lastLine; //lastLine is the last formatted object that was shown in the UI

                    if (formatted.rendered) {
                        formatted.text.splice(0); //remove previous lines if line was rendered
                        formatted.rendered = false;  //reset rendered flag so it will be rendered again
                        formatted.updated = true;   //make it available that this line was rendered before but was updated with additional text
                    }
                }

                formatted = _addFormattedInfo(formatted, options, needNewLine);
            }
        }

        return formatted;
    }

    /**
     * will go over the links in the node and make sure they all have target=_blank attributes
     * This is done separately from the sanitize html that is called when the line ibject is prepared
     * this is so there is no need to write complex regex or to load the html of the line twice into jQuery
     * @param node - a jquery object
     * @returns {*} - the node instance
     */
    function formatLinks(node) {

        if (!(node instanceof jQuery)) {
            throw new Error("chatLineFormatter - node must be a jquery object");
        }

        var links = node.find("a");

        links.each(function (i, link) {
            link.setAttribute("target", "_blank");
        });

        return node;
    }

    function _getNewFormattedLine(options) {

        var line = options.line;

        var formattedLine = {
            text: [],
            lineType: _getLineTypeFromSource(options),
            by: line.by,
            source: line.source,
            time: line.time,
            displayTime: "",
            textType: line.textType,
            byAvatar: "",
            displayBy: "",
            rendered: false, // if this line was already rendered to the UI
            updated: false //if this line was already rendered before and the text collection has been updated with additional lines
        };

        Object.defineProperty(formattedLine, "id", { //make sure id cannot be touched once its created
            value: _.uniqueId("chatLine"),
            enumerable: true   //can be found on the object when iterating over its properties
        });

        return formattedLine;
    }

    function _getFormattedSnippet(formatted, options) {

        var match = kpRegex.exec(options.line.text);    //EXAMPLE =  __KPDATA!:{"title":"About Campaigns","description":"An introduction to campaigns and their importance within LiveEngage.","thumbnail_1":"https://s3.amazonaws.com/LPGA/e2228706-b4b7-4912-8366-ee1668fd78b0_thumbnail","cb_key":"cms::con::63b4ef3f-79c1-4cf2-870c-8d5d529e73a6","locale":"en-US","layout":"Text and image","slug":"about-campaigns","metaData":""}

        if (match && match.length > 1) {
            var text = "{" + match[1].replace(/\&quot\;/g, "\"") + "}";
            var snippet = null;

            try {
                snippet = JSON.parse(text);
            }
            catch (ex) {
                logger.error("failed to parse snippet text as JSON!!!", "chatLineFormatter._getFormattedSnippet", ex);
                logger.graph({name:"connection:ChatLineFormatter:_getFormattedSnippet:failParseSnippet"});
            }

            if (snippet) {
                formatted.snippet = true;
                formatted.text.push(snippet);
            }
        }
        else {
            logger.warn("failed to match the snippet text as a valid KP string - ", "chatLineFormatter._getFormattedSnippet", options.line.text);
        }


        return formatted;
    }

    function _getFormattedCoBrowseInvitation(formatted, options) {

        var match = cbRegex.exec(options.line.text);

        if (match && match.length > 1) {
            formatted.serviceID = match[1];
        } else {
            logger.warn("failed to match the chat line text as a valid CoBrowse invitation - ", "chatLineFormatter._getFormattedCoBrowseInvitation", options.line.text);
        }

        return formatted;
    }

    function _addFormattedInfo(formatted, options, isNew) {

        var line = options.line;

        var formattedTextLines = _getFormattedText(formatted, options.line.text);

        formatted.text = formatted.text.concat(formattedTextLines);
        formatted.displayTime = _getDisplayTime(line);

        if (isNew) {
            formatted.displayBy = _getDisplayByName(formatted);
            formatted.byAvatar = _getAvatar(formatted, options);
        }

        return formatted;
    }

    function _getUserTextAsLines(text) {

        var lines = text.split(/\n/gm);

        if (lines.length > 0) {
            lines = _.reject(lines, function (val) {
                return (val.replace(/\s\s*$/, "").length === 0);
            });
        }

        return lines;
    }

    function _getFormattedText(formatted, text) {

        var textLines = [];

        if (_.isArray(text)) {

            textLines = _.map(text, function (textItem) {
                return _getValidLineText(textItem);
            });
        }
        else {
            textLines.push(_getValidLineText(text));
        }

        return textLines;
    }

    function _getDisplayTime(line) {

        var lineTime;

        try {
            if (line.time) {
                lineTime = new Date(line.time);
            }
        }
        catch (ex) {
            logger.error("failed to parse chat line time: " + line.time, "chatLineFormatter._getDisplayTime", ex);
            logger.graph({name:"connection:ChatLineFormatter:_getDisplayTime:failParseChatLineTime"});
            lineTime = new Date();
        }

        return lpUtils.formatDateAsShortTime(lineTime); //lineTime.toLocaleTimeString();
    }

    function _getAvatar(formatted, options) {
        var avatar;

        switch (formatted.lineType) {
            case CP_CONST.CHAT_LINE_TYPES.VISITOR:
                avatar = options.profileAvatar;
                break;
            case CP_CONST.CHAT_LINE_TYPES.AGENT:
                avatar = options.contactAvatar;
                break;
            case CP_CONST.CHAT_LINE_TYPES.ANOTHER_AGENT:
                avatar = options.defaultContactAvatar;
                break;
        }

        return avatar;
    }

    function _getDisplayByName(formatted) {

        var name = formatted.by;

        if (name.toLowerCase() === CP_CONST.CHAT_DEFAULT_USER_NAME) {
            name = LE.translator.translate("LEConnection.chat.participantDefaultName");
        }

        return name;
    }

    function _getValidLineText(text) {

        var validText = text;

        if (lpUtils.hasHtml(text)) {
            validText = _sanitizeText(text); //remove html elements like script or iframe
        }

        return validText;
    }

    function _sanitizeText(text) {

        var sanitized = text;

        _.each(sanitizeTextActions, function (action) {
            try {
                sanitized = sanitized.replace(action.regEx, action.replaceString);
            }
            catch (ex) {
                logger.error("Error when trying to cleanup text, cleanupType: " + action.type + " text: " + text + " result: " + sanitized, "chatLineFormatter._sanitizeText", ex);
                logger.graph({name:"connection:ChatLineFormatter:_sanitizeText:failSanitation"});
            }
        });

        return sanitized;
    }

    function _isNewLineNeeded(line, lastLine, reset) {

        var newLine = true;

        if (!reset && lastLine) {
            newLine = (lastLine.lineType !== line.lineType || lastLine.by !== line.by);
        }

        return newLine;
    }

    function _getLineTypeFromSource(options) {

        var line = options.line,
            lineType = line.source,
            LINE_TYPES = CP_CONST.CHAT_LINE_TYPES;

        if (lineType === LINE_TYPES.AGENT) {

            if (line.text.indexOf(CHAT_LINE_SNIPPET_INDICATOR) > -1) { //this is a snippet
                lineType = LINE_TYPES.SNIPPET;
            } else if (line.text.indexOf(COBROWSE_DATA_ATTR) > -1) { // this is a cobrowse invitation
                lineType = LINE_TYPES.COBROWSE;
            }
            else if (!options.skillChat && line.by && options.contactName && line.by !== options.contactName) {//An agent line coming back from the server that's not from the same Agent - only when chat started with a contact and not with a skill
                lineType = LINE_TYPES.ANOTHER_AGENT;
            }
        }

        return lineType;
    }

    return {
        getUserLineFromText: getUserLineFromText,
        getFormattedLine: getFormattedLine,
        formatLinks: formatLinks
    };
});
